
    import { createIcons, Activity, AlertCircle, AlertTriangle, Apple, ArrowDown, ArrowUp, Award, Beef, Calendar, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft, ChevronRight, ClipboardList, Coffee, CreditCard, Download, Dumbbell, Edit2, ExternalLink, File, FileText, Flag, FolderOpen, Globe, History, Home, Info, LayoutDashboard, LayoutList, LifeBuoy, ListOrdered, Loader2, Lock, LogOut, MinusCircle, MoreVertical, Play, Plus, PlusCircle, RefreshCw, Save, Scale, Search, Settings, ShieldCheck, Target, Timer, Trash2, Upload, User, VideoOff, Weight, X, XCircle } from 'lucide';

    // public/js/main.js

import { ToastManager } from './components/toast-manager.js';
import initAlert from './components/alert.js';
import initButtonLoader from './components/button-loader.js';
import initCheckbox from './components/checkbox.js';
import initCustomSelect from './components/custom-select.js';
import initDropdown from './components/dropdown.js';
import initFileUpload from './components/file-upload.js';
import initInput from './components/input.js';
import initModal from './components/modal.js';
import initPaymentForm from './components/payment-manager.js';
import initPhoneInput from './components/phone-input.js';
import initRadioGroup from './components/radio-group.js';
import initTabs from './components/tabs.js';
import initTooltip from './components/tooltip.js';
import initGoalSheet from './components/goal-sheet.js';
import initListFilter from './components/list-filter.js';
import initSettingsMenu from './components/settings-menu.js';

const COMPONENT_REGISTRY = {
  'alert': initAlert,
  'button-loader': initButtonLoader,
  'checkbox': initCheckbox,
  'custom-select': initCustomSelect,
  'dropdown': initDropdown,
  'file-upload': initFileUpload,
  'input': initInput,
  'modal': initModal,
  'payment-form': initPaymentForm,
  'phone-input': initPhoneInput,
  'radio-group': initRadioGroup, 
  'tabs': initTabs,
  'tooltip': initTooltip,
  'goal-sheet': initGoalSheet,
  'list-filter': initListFilter,
  'settings-menu': initSettingsMenu,
};

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.cookie = `tz_offset=${new Date().getTimezoneOffset()}; path=/; max-age=31536000; SameSite=Lax`;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      
      const toastManager = new ToastManager();

      const componentElements = document.querySelectorAll('[data-component]');
      componentElements.forEach((el) => {
        const name = el.dataset.component;
        const initFn = COMPONENT_REGISTRY[name];
        if (initFn) {
          try {
            initFn(el);
          } catch (err) {
            console.warn(`Error initializing ${name}:`, err);
          }
        }
      });

      const forms = document.querySelectorAll('form');
      forms.forEach((form) => {
        form.setAttribute('novalidate', 'true');

        form.addEventListener('submit', (e) => {
          let isFormValid = true;
          let firstInvalidElement = null;

          const componentsInForm = form.querySelectorAll('[data-component]');
          
          componentsInForm.forEach((el) => {
            if (typeof el.validate === 'function') {
              const isValid = el.validate();
              if (!isValid) {
                isFormValid = false;
                if (!firstInvalidElement) firstInvalidElement = el;
              }
            }
          });

          if (!isFormValid) {
            e.preventDefault();
            e.stopPropagation();
            
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn && typeof submitBtn.stopLoading === 'function') {
              submitBtn.stopLoading();
            }

            if (firstInvalidElement) {
              firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        });
      });

      const flashEl = document.getElementById('flash-payload');
      if (flashEl) {
        const message = flashEl.dataset.message;
        const type = flashEl.dataset.type || 'info';
        
        if (message) {
          toastManager.show(message, type);
        }
      }

    });
  });
});

    document.addEventListener('DOMContentLoaded', () => {
      if (typeof createIcons === 'function') {
        createIcons({
          icons: { Activity, AlertCircle, AlertTriangle, Apple, ArrowDown, ArrowUp, Award, Beef, Calendar, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft, ChevronRight, ClipboardList, Coffee, CreditCard, Download, Dumbbell, Edit2, ExternalLink, File, FileText, Flag, FolderOpen, Globe, History, Home, Info, LayoutDashboard, LayoutList, LifeBuoy, ListOrdered, Loader2, Lock, LogOut, MinusCircle, MoreVertical, Play, Plus, PlusCircle, RefreshCw, Save, Scale, Search, Settings, ShieldCheck, Target, Timer, Trash2, Upload, User, VideoOff, Weight, X, XCircle },
          attrs: { 'class': 'lucide-icon', 'aria-hidden': 'true' }
        });
      }
    });
  